import React, { useContext, useEffect, useState } from 'react';
import './UserProfile.css';
import '../../component/post/post.css';
import PostCard from "../../component/layouts/PostCard";
import Helmet from '../../component/Helmet/Helmet';
import Sidebar from '../../component/layouts/Sidebar';
import MobileTopBar from '../../component/layouts/MobileTopBar';
import RightSide from '../../component/layouts/rightSide';
import { AppContext } from '../../context/AppContext';
import { useParams } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import AllPopups from '../../component/layouts/AllPopups';
import FifaCard from '../../component/Avatar/Avatar';


const UserProfile = () => {
  const { user, token, setShowLogin, setShowEditProfile } = useContext(AppContext);
  const { user_id,username } = useParams();

  const [followers, setFollowers] = useState([]);
  const [followings, setFollowings] = useState([]);
  const [postsCount, setPostsCount] = useState(0);
  const [userProfile, setUserProfile] = useState(null);
  const [reviews, setReviews] = useState(0);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [posts, setPosts] = useState([]);
  const [likedPosts, setLikedPosts] = useState({});
  const [loadingUserProfile, setLoadingUserProfile] = useState(true);
  const [followingState, setFollowingState] = useState(false);




 
  const getDataOfUser = async () => {
    try {
      const response = await fetch('https://dashboard.tiktaka.com/api/getDataOfUser', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ hashed_id: user_id })
      });
      const data = await response.json();

      console.log(111);
      console.log(data);
      
      if (response.ok) {
        setFollowers(data.followers || []);
        setFollowings(data.followings || []);
        setPostsCount(data.userPostsCount || 0);
        setUserProfile(data.userProfile);
        setReviews(data.reviews);
        // window.location.reload();

        

        console.log('==============!!!!=====================');
        console.log(data);
        console.log(data.reviews);
        console.log('====================================');


        
        // ضبط حالة المتابعة
        // setFollowingState(data.userProfile?.is_followed || false);
      }
    } catch (error) {
      console.error(error);
    }
    setLoadingUserProfile(false);
  };

  // متابعة / إلغاء متابعة
  const handleFollowToggle = async () => {
    if (!user) return setShowLogin(true);

    const url = followingState
      ? 'https://dashboard.tiktaka.com/api/makeUnfollow'
      : 'https://dashboard.tiktaka.com/api/makeFollow';

    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ followed_id: userProfile.id })
      });

      const data = await res.json();
      if (res.status === 401) return setShowLogin(true);

      if (res.ok) setFollowingState(!followingState);
    } catch (err) {
      console.error(err);
    }
  };

  const toggleLike = async (postId) => {
    setLikedPosts((prev) => ({ ...prev, [postId]: !prev[postId] }));
    const response = await fetch('https://dashboard.tiktaka.com/api/likeAndUnlike', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ post_id: postId })
    });
    if (response.ok) getPosts();
  };

  const getPosts = async () => {
    const res = await fetch('https://dashboard.tiktaka.com/api/userProfilePosts', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ hashed_id: user_id })
    });
    const data = await res.json();
    if (res.ok) setPosts(data.posts || []);
  };

  const handleRating = async (currentRating) => {
    setRating(currentRating);
    try {
      const response = await fetch('https://dashboard.tiktaka.com/api/storeRating', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          rating: currentRating,
          hashed_id: user_id,
          authUserId: user?.hashed_id
        })
      });
      if (response.status === 401) setShowLogin(true);
      else if(response.status === 200){
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    }
  };



  useEffect(() => {
    getDataOfUser();
    getPosts();

      if (user && user.id) {
        const isFollowingUser = (followers || []).some(follower => follower.id === user.id);
        setFollowingState(isFollowingUser);
    }

  }, [user_id,user]);

  return (
    <Helmet title="Profile">
      <AllPopups userProfile={!loadingUserProfile ? userProfile : null} getDataOfUser={getDataOfUser} />
      <div className="Profile">
        <Sidebar />
        <div className="midSide">
          <div className="middleSideHome">
            <MobileTopBar />
            <div className="mainSection">
              <div className="profile-wrapper">
                <div className="profile-header">
                
                  {/* <div style={{ height: '60px' }}> */}
                      <FifaCard

                        name={userProfile?.name || "Player"}
                        fav_number={userProfile?.fav_number || ""}
                        foot={userProfile?.foot || ""}
                        position={userProfile?.position || ""}
                        profilePicture={
                          userProfile?.avatar
                            ? userProfile.avatar.includes('original_')
                              ? `https://dashboard.tiktaka.com/${userProfile.avatar.replace('original_', 'no_bg_')}`
                              : `https://dashboard.tiktaka.com/${userProfile.avatar}`
                            : ''
                        
                        }
                    />

                {/* </div> */}

                  {/* <img
                    src={userProfile?.avatar ? `https://dashboard.tiktaka.com/${userProfile.avatar}` : defaultUserProfile}
                    width="60"
                    height="60"
                    alt="user Profile"
                    className="avatar"
                  /> */}


                  <div className="profile-info">
                    {/* <h1 className="display-name">{userProfile?.name}</h1> */}
                  </div>
                  <div className="profile-stats">
                    <div className="profile-stat">
                      <strong>{followings.length}</strong>
                      <span>Following</span>
                    </div>
                    <div className="profile-stat">
                      <strong>{followers.length}</strong>
                      <span>Followers</span>
                    </div>
                    <div className="profile-stat">
                      <strong>{postsCount}</strong>
                      <span>Posts</span>
                    </div>
                  </div>

                  {user?.hashed_id === user_id ? (
                    <div className="profile-controls">
                      <div className="stacked-button">
                        <button className="follow" id="following" onClick={() => setShowEditProfile(true)}>
                          <span className="follow-text">Edit Profile</span>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="profile-controls">
                      <div className="stacked-button" style={{ marginLeft: '40px' }} >
                        <button className="follow" id="following" onClick={handleFollowToggle}>
                          <span className="follow-text" >
                                  
                            {followingState ? 'Unfollow' : 'Follow'}
                          </span>
                        </button>
                      </div>
                      <div className="rateMe" style={{ marginTop: '10px' }}>

                        {[...Array(5)].map((_, index) => {
                          const currentRating = index + 1;
                          return (
                            <label key={index}>
                              <input
                                type="radio"
                                name="rating"
                                value={currentRating}
                                onClick={() => handleRating(currentRating)}
                              />
                              <FaStar
                                className="star"
                                size={25}
                                color={currentRating <= (hover || rating) ? '#ffc107' : '#e4e5e9'}
                                onMouseEnter={() => setHover(currentRating)}
                                onMouseLeave={() => setHover(null)}
                              />
                            </label>
                          );
                        })}

                          <span style={{ marginLeft: '10px' }}>
                            
                             {  reviews.total_reviews !==0 ?  ((reviews.total_stars/reviews.total_reviews).toFixed(2)
                             ) : (0.00)}  { ' ( ' + reviews.total_reviews + ' reviews )' } </span>
                      </div> 

                    </div>
                  )}
                </div>

                <div className="postSection" style={{ width: '100%' }}>
                  {posts.length > 0 ? (
                    posts.map((post) => (
                      <PostCard
                        key={post.id}
                        post={post}
                        user={user}
                        token={token}
                        toggleLike={toggleLike}
                        getPosts={getPosts}
                      />
                    ))
                  ) : (
                    <p>There is no posts</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <RightSide />
      </div>
    </Helmet>
  );
};

export default UserProfile;
